module.exports = __webpack_public_path__ + "images/155_640.jpg";